import { Card } from 'components'
import { translate } from 'locales'
import React, { useState } from 'react'

import chevronDownIcon from 'assets/icons/chevron-down-gray.svg'
import { Header } from 'components'
import Loading from 'components/Loading'
import * as Global from 'global/styles.global'
import useFetch from 'hooks/useFetch'
import { modalManager } from 'modal'
import * as S from './styles'

const ConfirmModal = ({
  onClose,
  message,
}: {
  onClose: () => void
  message: string
}) => (
  <div>
    <p>{message}</p>
    <button onClick={onClose}>Close</button>
  </div>
)


const FAQ = () => {
  const [expandedItems, setExpandedItems] = useState<number[]>([])
  const { data, isLoading } = useFetch({
    url: `/backoffice/ms/v1/faqs?type=doctor`,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const toggleExpanded = (id: number) => {
    setExpandedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    )
  }

  return (
    <Global.Container>
      {isLoading && <Loading title={translate('loadings.loading')} />}
      <Header />
      <S.Content>
        <div className="faq-top">
          <h1 className="title-faq">FAQ</h1>
          {/* <div className="search-faq">
            <Search
              name="search-faq"
              placeholder="Busque o que precisa"
              value={''}
              onChange={() => {}}
            />
            <Button
              color="primary"
              onClick={() => {}}
              type="button"
              title="Buscar"
            >
              {translate('patients.search')}
            </Button>
            <Button
              color="primary-light"
              onClick={() => {}}
              type="button"
              title="Limpar"
            >
              {translate('patients.clean')}
            </Button>
          </div> */}
        </div>
        <Card>
          {data?.map((item: any) => {
            const isExpanded = expandedItems.includes(item.id)
            return (
              <S.FAQItem key={item.id}>
                <S.FAQHeader
                  onClick={() => toggleExpanded(item.id)}
                  isExpanded={isExpanded}
                >
                  <S.FAQTitle>{item.question}</S.FAQTitle>
                  <S.FAQIcon isExpanded={isExpanded}>
                    <img src={chevronDownIcon} alt="Expandir" />
                  </S.FAQIcon>
                </S.FAQHeader>
                {isExpanded && (
                  <S.FAQContent>
                    <S.FAQText>{item.answer}</S.FAQText>
                  </S.FAQContent>
                )}
              </S.FAQItem>
            )
          })}
        </Card>
      </S.Content>
    </Global.Container>
  )
}

export default FAQ
